import TagManagementReducer from 'store/tag-management/reducers';

export default TagManagementReducer;
